import { Policy } from '../types';

// Existence is not enough: a detached policy survives with no scanner behind it,
// so this counts the environments it reached. In-progress and an absent
// breakdown both count as deploying, to avoid warning during a rollout.
export function isDeployingScanner(policy: Policy): boolean {
  if (policy.Type !== 'vulnerability-scanning-k8s') {
    return false;
  }

  const breakdown = policy.StatusBreakdown;
  if (!breakdown) {
    return true;
  }

  return breakdown.Applied + breakdown.Warning + breakdown.InProgress > 0;
}
